import { useCallback, useState } from 'react';
import type { IphoneSmsConversation } from '@casetrace/shared';

export type ConversationSelection = {
  readonly selected: Set<string>;
  readonly allVisibleSelected: boolean;
  readonly toggle: (chatId: string) => void;
  readonly toggleAllVisible: () => void;
};

export function useConversationSelection(visible: IphoneSmsConversation[]): ConversationSelection {
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const allVisibleSelected =
    visible.length > 0 && visible.every((conversation) => selected.has(conversation.chatId));

  const toggle = useCallback((chatId: string) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(chatId)) {
        next.delete(chatId);
      } else {
        next.add(chatId);
      }
      return next;
    });
  }, []);

  const toggleAllVisible = useCallback(() => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (visible.every((conversation) => next.has(conversation.chatId))) {
        visible.forEach((conversation) => next.delete(conversation.chatId));
      } else {
        visible.forEach((conversation) => next.add(conversation.chatId));
      }
      return next;
    });
  }, [visible]);

  return { selected, allVisibleSelected, toggle, toggleAllVisible };
}
